import React from 'react';
import {withRouter, Link} from "react-router-dom";
import { connect } from 'react-redux';
import { SamplesActions } from './../actions';
import Api from './../api/api';

const SEND_SAMPLES_en = 'Send Samples';
const SENDING_SAMPLES_en = 'Sending';

class AddToSample extends React.Component {

    state={
        email:'',
        firstName:'',
        lastName:'',
        companyName:'',
        phone:'',
        address:'',
        address2:'',
        city:'',
        country:'',
        zip:'',
        addToSampleState: false,
        sendBtnText: SEND_SAMPLES_en,
    }

    onChangeInput = (e, inputType) => {
        this.setState({[inputType]: e.target.value});
    }

    closeSamplesOnRouteChange = () =>{
        this.unlisten = this.props.history.listen(location => {
            this.props.openSamples(false);
        });
    }

    componentDidMount(){
        this.closeSamplesOnRouteChange();
        document.addEventListener("keydown", this.escFunction, false)
    }


    escFunction = (event) =>{
        if(event.keyCode === 27) {
            this.props.openSamples(false);
        }
    }

    componentWillUnmount(){
        this.unlisten();
        document.removeEventListener("keydown", this.escFunction, false);
    }

    addToSampleSubmit = () => {
        const {email,firstName: first_name,lastName: last_name,companyName,phone,address,address2,city,country,zip:zip_code} = this.state;
        const data = {
            email,
            first_name,
            last_name,
            companyName,
            phone,
            shipping_list: this.props.samples.map((sample)=>{
                const { 
                    title : color,
                    collection : collection_name,
                    type
                } = sample;
                return {
                    collection_name,
                    type,
                    color
                }
            }),
            address,
            address2,
            city,
            country,
            zip_code
        };

        this.setState({sendBtnText: SENDING_SAMPLES_en});
        Api.postRequestSamples(data).then(()=>{
            this.setState({
                addToSampleState: true,
            },()=>{
                setTimeout(()=>{
                    this.props.deleteAllSamples();
                    this.setState({
                        sendBtnText: SEND_SAMPLES_en,
                        addToSampleState:false,
                        email:'',
                        firstName:'',
                        lastName:'',
                        companyName:'',
                        phone:'',
                        address:'',
                        address2:'',
                        city:'',
                        country:'',
                        zip:''
                   });
                }, 5000)
            });
        });
    }

    renderSelectedSamples = () => {
        const {langTxt, samples} = this.props;
        let content = [];
        for(let i = 0; i < 6; i++){
            const sample = samples[i];
            if(sample){
                content.push(
                    <div className="right-item">
                        <p className="remove-sample cursor-pointer" onClick={()=>this.props.removeSample(sample)}>x</p>
                        <img src={sample.image_url} alt=""/>
                        <p>{sample.collection}</p>
                        <p>{sample.title}</p>
                    </div>
                );
            }else{
                content.push(<div className="right-item blank-item"></div>);
            }
        }


        return content.map((item)=> item)
    }

    renderMySamples = () => {
        const {langTxt,langUrl,samples} = this.props;
        console.log(samples.length)
        const openedClass = (this.props.formOpened)? "d-none" : '';
        return (
            <div className="my-samples">
                <div className="my-samples-wrapper">
                    <div className="left">
                        <p>Choose <Link to={langUrl+"/collections"}>up to 6 samples</Link></p>
                    </div>
                    <div className="right">
                        {this.renderSelectedSamples()}
                    </div>
                </div>
                {(samples.length >0)? 
                    <div className="req-sample">
                        <div className={"btn-wrapper btn-style " +openedClass} onClick={()=>this.props.openSamplesForm(true)}>
                            <p >Request Samples</p>
                        </div>
                    </div> :''}
            </div>
        )
    }

    renderShippingDetails = () =>{
        const openedClass = (this.props.formOpened)? "opened" : '';
        return (
            <div className={"shipping-details " + openedClass}>
                <div className="shipping-details-wrapper">
                    <div className="shipping-details-title">
                        <p>Shipping Details</p>
                    </div>
                    <div className="shipping-details-form">
                        <div className="shipping-details-form-left">
                            <div className="first-name">
                                <p className="cursor-pointer" onClick={()=>document.getElementById("shipping-first-name").focus()}>First Name</p>
                                <input id="shipping-first-name" value={this.state.firstName} onChange={(e)=>this.onChangeInput(e, 'firstName')} type="text" />
                            </div>
                            <div className="last-name">
                                <p className="cursor-pointer" onClick={()=>document.getElementById("shipping-last-name").focus()}>Last Name</p>
                                <input id="shipping-last-name" value={this.state.lastName} onChange={(e)=>this.onChangeInput(e, 'lastName')} type="text" />
                            </div>
                            <div className="company-name">
                                <p className="cursor-pointer" onClick={()=>document.getElementById("shipping-company-name").focus()}>Company Name</p>
                                <input id="shipping-company-name" value={this.state.companyName} onChange={(e)=>this.onChangeInput(e, 'companyName')} type="text" />
                            </div>
                            <div className="email">
                                <p className="cursor-pointer" onClick={()=>document.getElementById("shipping-email").focus()}>Email Address</p>
                                <input id="shipping-email" value={this.state.email} onChange={(e)=>this.onChangeInput(e, 'email')} type="email" />
                            </div>
                            <div className="phone">
                                <p className="cursor-pointer" onClick={()=>document.getElementById("shipping-phone").focus()}>Phone</p>
                                <input id="shipping-phone" value={this.state.phone} onChange={(e)=>this.onChangeInput(e, 'phone')} type="tel" />
                            </div>
                        </div>


                        <div className="shipping-details-form-right">
                            <div className="address">
                                <p className="cursor-pointer" onClick={()=>document.getElementById("shipping-address").focus()}>Address</p>
                                <input id="shipping-address" value={this.state.address} onChange={(e)=>this.onChangeInput(e, 'address')} type="text" />
                            </div>
                            <div className="address-2">
                                <p className="cursor-pointer" onClick={()=>document.getElementById("shipping-address-2").focus()}>Address 2 (Optional)</p>
                                <input id="shipping-address-2" value={this.state.address2} onChange={(e)=>this.onChangeInput(e, 'address2')} type="text" />
                            </div>
                            <div className="city">
                                <p className="cursor-pointer" onClick={()=>document.getElementById("shipping-city").focus()}>City</p>
                                <input id="shipping-city" value={this.state.city} onChange={(e)=>this.onChangeInput(e, "city")} type="text" />
                            </div>
                            <div className="country">
                                <p className="cursor-pointer" onClick={()=>document.getElementById("shipping-country").focus()}>Country</p>
                                <input id="shipping-country" value={this.state.country} onChange={(e)=>this.onChangeInput(e, 'country')} type="text" />
                            </div>
                            <div className="zip-code">
                                <p className="cursor-pointer" onClick={()=>document.getElementById("shipping-zip").focus()}>ZIP Code</p>
                                <input id="shipping-zip" value={this.state.zip} onChange={(e)=>this.onChangeInput(e, 'zip')} type="text" />
                            </div>
                        </div>
                        <div className="req-sample">
                            <div onClick={()=>this.addToSampleSubmit()} className="btn-wrapper btn-style">
                                <p>{this.state.sendBtnText}</p>
                            </div>
                        </div>
                    </div>    
                </div>
            </div>
        )
    }

    render (){
        const {langTxt, langUrl, opened} =this.props;
        const {addToSampleState} = this.state;
        const openedClass = opened? 'opened' : '';
        const openedShipping = (this.props.formOpened)? " shipping-opened" : '';
       return (
            <div className={"add-to-sample-container " + openedClass + openedShipping}>
                {(addToSampleState)? 
                    <div className="sample-submitted">
                        <p>Thank you for your request, our experts will be in touch with you soon.</p>
                        <p>Continue to discover our collections</p>
                    </div>
                :
                    <>
                        {this.renderMySamples()}
                        {this.renderShippingDetails()}
                    </>
                }
                
            </div>
       );
    }
}

// what props do i need to get from the state for this component?
const mapStateToProps = (state) => {
    // get the props needed for this component from the state of the store.
    return {
        opened: (state.samples && state.samples.opened),
        formOpened: (state.samples && state.samples.formOpened),
        samples: (state.samples && state.samples.list) || [],
        langTxt: (state.lang && state.lang.text) || 'en',
        langUrl: (state.lang && state.lang.url) || '',

    }
}

// what events will occur that will change the state in this component
const mapDispatchToProps = (dispatch) => {
    return {
        openSamples: (isOpened) => dispatch(SamplesActions.open(isOpened)),
        openSamplesForm: (isOpened) => dispatch(SamplesActions.openForm(isOpened)),
        removeSample: (sample) => dispatch(SamplesActions.del(sample)),
        deleteAllSamples: () => dispatch(SamplesActions.delAll())

    };
};

export default withRouter( connect(mapStateToProps, mapDispatchToProps)(AddToSample) );